var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _circle2, _circle3, _circle4, _circle5, _path7, _path8, _path9, _path0, _path1, _circle6, _circle7, _path10, _circle8, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKrytenAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 72,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 248,
    r: 182,
    fill: "url(#halo)",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 389C186 332 219 304 256 304C293 304 326 332 340 389L351 438H161L172 389Z",
    fill: "url(#body)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204 340H308",
    stroke: "#9EB7C9",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221 370H291",
    stroke: "#5ED7FF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197 151L226 103H286L315 151L343 164L334 294C332 327 305 353 272 353H240C207 353 180 327 178 294L169 164L197 151Z",
    fill: "url(#head)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226 103H286L302 134H210L226 103Z",
    fill: "#D9E5EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200 179C218 154 237 143 256 143C275 143 294 154 312 179",
    stroke: "#F7FBFF",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 180,
    width: 108,
    height: 68,
    rx: 30,
    fill: "#21313E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 192,
    width: 84,
    height: 44,
    rx: 20,
    fill: "#5DE6FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 214,
    r: 12,
    fill: "#E8FDFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 214,
    r: 12,
    fill: "#E8FDFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 214,
    r: 5,
    fill: "#278AA7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 214,
    r: 5,
    fill: "#278AA7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223 272C243 286 269 286 289 272",
    stroke: "#4FB9D6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207 262H305",
    stroke: "#D7E5EF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223 302H289",
    stroke: "#A9C2D4",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M160 159L187 183",
    stroke: "#D4E1EA",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M352 159L325 183",
    stroke: "#D4E1EA",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 159,
    r: 16,
    fill: "#5DE6FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 159,
    r: 16,
    fill: "#5DE6FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212 63H300",
    stroke: "#D9E5EF",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 56,
    r: 18,
    fill: "#5DE6FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188 401H324",
    stroke: "#DDE9F1",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M205 423H307",
    stroke: "#7EDFFF",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 54,
    y1: 52,
    x2: 463,
    y2: 458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#17324A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335F7C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256 214) rotate(90) scale(232)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "head",
    x1: 185,
    y1: 109,
    x2: 331,
    y2: 336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C9D7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FA8BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "body",
    x1: 184,
    y1: 317,
    x2: 329,
    y2: 445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#AFBFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B95A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrytenAvatar);
export default __webpack_public_path__ + "static/media/kryten-avatar.b7c2c4a9dfe773bfced438d302bcd7e2.svg";
export { ForwardRef as ReactComponent };